import type { View } from "@/components/expression/utils/NodeStyleProvider";
import type { NodeSize, SymbolFontContext } from "@corca/data";

/**
 * Rendering context a symbol's font resolves against.
 *
 * Compact previews are inline contexts, so large operators render from their
 * default glyph there rather than the oversized display one.
 *
 * TODO: label children should be textstyle too
 * @see https://linear.app/corca-research/issue/D-3126/use-textstyle-in-labels-maybe
 */
export function getSymbolFontContext(view: View, size: NodeSize): SymbolFontContext {
  return {
    mathStyle: view === "compact-expression" ? "textstyle" : "displaystyle",
    size,
  };
}
